
import React from 'react';
import { PropTypes } from 'prop-types';
import { Helmet } from 'react-helmet';
import brand from '../../../utils/brand';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import SintesisMenu from '../../../components/Header/SintesisMenu';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import SearchIcon from '@material-ui/icons/Search';
import Today from '@material-ui/icons/Today';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import FilterList from '@material-ui/icons/Tune';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import KeyboardTab from '@material-ui/icons/KeyboardTab';
import Hidden from '@material-ui/core/Hidden';
import styles from './search-jss'
import './searchs-css.css';
import GridCard from '../../../components/Grids/GridCard';
import SliderEditoriales from '../../../components/Sliders/SliderEditoriales';
import SliderCartones from '../../../components/Sliders/SliderCartones';
import SliderRadio from '../../../components/Sliders/SliderRadio';
import SliderEvent from '../../../components/Sliders/SliderEvent';
import Event from '../../../components/Event/Event';
import Portadas from '../../../components/Portadas/Portadas';
import SliderTap from '../../../components/Sliders/SliderTap';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PapperBlock from '../../../components/PapperBlock/PapperBlock';
import { fetchCall } from '../../../service/service_base';
import Footer from '../../../components/Footer/Footer';
import ls from 'local-storage';
import { ThemeContext } from '../../../utils/ThemeContext';
import ReactiveBaseStyle from './ReactiveBaseStyle';
import { DataSearch, SelectedFilters, ReactiveList, MultiDataList, DateRange } from '@appbaseio/reactivesearch';
import MomentLocaleUtils, {
  // formatDate
} from 'react-day-picker/moment';
import 'moment/locale/es';
// import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { _getDateShort } from '../../../utils/dateFormat'
import { Link } from 'react-router-dom';
import LoaderFull from '../../../components/Loader/LoaderFull';
import CardButton from '../../../components/CardButton/CardButton';
import { Snackbar } from '@material-ui/core';
import CustomNotification from '../../../components/Notification/CustomNotification';

const noRender = ["Header", "Banner", "Portadas", "Footer"];
const initDate = new Date();
initDate.setHours(initDate.getHours() + 24)
class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idMenuSelected: ls.get('menuSelected'),
      synthesisAvailable: [],
      synthesisSections: [],
      isLoading: true,
      columnists: [],
      kicker: [],
      allSynthesis: [],
      //Drawer
      isOpen: false,
      //datepicker
      anchorEl: null,
      currentMenu: '',
      availableSection: [],
      date: { start: new Date(), end: initDate },
      //reactivevalues
      searchValue: "",
      sectionValue: [],
      kickerValue: [],
      columnistValue: [],
      synthesisValue: [],
      dateValue: null,
      defaultSectionValue: null
    }

    this.dataSearchRef = React.createRef();
    this.columnistSuggestionsBuffer = [];
  }

  // PARA MENU DE SINTESIS

  componentDidMount() {
    this._loadSynthesis();
    this._getcolumnistsByList(this.state.idMenuSelected);
  }

  _loadSynthesis = () => {
    fetchCall("GET", "/synthesis/get").then(
      response => {
        let available = [];
        if (response.status === 200) {
          if (response.data.length > 0) {
            response.data.forEach(item => {
              let parse = JSON.parse(`[${ls.get('current_user').availableSynthesis}]`);
              if (parse !== undefined) {
                if (parse.filter(x => parseInt(x.id) === parseInt(item.menu_id))[0]) {
                  if (item.lastPublish && item.menu_public===0 && item.menu_visible===1) {
                    available.push(item);
                  }
                }
              }
            })
          }
        }

        this.setState({
          synthesisAvailable: available,
          allSynthesis: response.data.filter(item => item.menu_visible === 1).map(item => ({ label: item.menu_name, value: item.menu_name })),
          currentMenu: available.filter(x => x.menu_id === this.state.idMenuSelected)[0]["menu_name"],
        }, () => {
          this.context.toggleTheme(available.filter(x => x.menu_id === this.state.idMenuSelected)[0]);
          this._loadSectionBySynthesis(this.state.idMenuSelected);
          this._getKickersByList(this.state.idMenuSelected);
        });
      }
    ).catch(
      err => {

      }
    );
  }

  _loadSectionBySynthesis = (menu_id) => {
    this.setState({
      synthesisSections: []
    }, () => {
      fetchCall("POST", "/synthesis/getsection", {
        menuId: menu_id
      }).then(response => {

        if (response && response.data && response.data.length > 0) {
          let aux = [];
          response.data.map(
            item => {
              if (item.sec_tipo === "Header") {
                item.idMenuSelected = this.state.idMenuSelected;
                this.context.toggleHeader(item);
              }
              if (item.sec_tipo === "Footer") {
                item.idMenuSelected = this.state.idMenuSelected;
                this.context.toggleFooter(item);
              }
              if (!noRender.includes(item.sec_tipo)) {
                aux.push(
                  {
                    label: item.sec_name,
                    value: item.sec_name
                  }
                )
              }
            }
          )
          const defaultColumnsSection = aux.find(section => section.label && section.label.toLowerCase().includes('column'));
          this.setState(
            {
              availableSection: aux,
              idMenuSelected: menu_id,
              sectionValue: defaultColumnsSection ? [defaultColumnsSection.value] : [],
              defaultSectionValue: defaultColumnsSection ? defaultColumnsSection.value : null
            }
          )
        }
      }).catch(err => console.log(err));
    });
  }

  _getKickersByList = (menu_id) => {
    fetchCall("GET", "/kicker/get").then(response => {
      this.setState({
        kicker: response.data.filter(x => (x.menu_id === menu_id && x.kicker_status === 1)).map(e => { return { label: e.kicker_name, value: `${e.kicker_name},${e.kicker_color}` } })
      });
    }).catch(err => console.log(err));
  }


  _getcolumnistsByList = (menu_id) => {
    fetchCall("GET", "/columnist/get").then(response => {
      const columnistsData = response.data
        .filter(x => (x.menu_id === menu_id && x.columnist_status === 1 && x.isEditorial !== 1))
        .map(e => ({ label: e.columnist_name, value: e.columnist_name, menu_id: e.menu_id }))
        .sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0)); // sort alphabetically
      this.setState({ columnists: columnistsData }, () => {
        console.log("menu_id", menu_id);
        console.log("columnists", this.state.columnists);
      });

    }).catch(err => console.log(err));
  }

  ensureDefaultSectionSelected = () => {
    this.setState(prevState => {
      const { defaultSectionValue } = prevState;
      if (!defaultSectionValue) {
        return null;
      }
      const current = Array.isArray(prevState.sectionValue) ? prevState.sectionValue : [];
      if (current.includes(defaultSectionValue)) {
        return null;
      }
      return { sectionValue: [...current, defaultSectionValue] };
    });
  }

  escapeRegExp = (text = '') => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  stripHtml = (text = '') => {
    if (!text) {
      return '';
    }
    return `${text}`.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  renderHighlightedText = (text, query) => {
    if (!text) {
      return text;
    }
    const safeQuery = query ? query.trim() : '';
    if (!safeQuery) {
      return text;
    }
    const escapedQuery = this.escapeRegExp(safeQuery);
    if (!escapedQuery) {
      return text;
    }
    const matcher = new RegExp(`(${escapedQuery})`, 'ig');
    const parts = `${text}`.split(matcher);
    if (parts.length <= 1) {
      return text;
    }
    return parts.map((part, index) => {
      if (!part) {
        return null;
      }
      const isMatch = index % 2 === 1;
      return isMatch ? (
        <span key={`match-${index}-${part}`} className={this.props.classes.highlightText}>{part}</span>
      ) : (
        <React.Fragment key={`text-${index}`}>{part}</React.Fragment>
      );
    });
  }

  extractColumnistSuggestionMeta = (item, fallbackIndex = 0) => {
    const source = item && item.source ? item.source : {};
    console.log("source del col", source);
    const rawContentName = source.cont_program || '';
    console.log("rawContentName", rawContentName);
    const rawProgram = source.cont_name || '';
    console.log("rawProgram", rawProgram);
    const rawDescription = source.cont_description || '';
    const contentName = this.stripHtml(rawContentName);
    const program = this.stripHtml(rawProgram);
    const description = this.stripHtml(rawDescription);
    const baseValue = (item && (item.value || item.title)) ? (item.value || item.title) : '';
    const compositeTitle = [contentName, program].filter(Boolean).join(' - ');
    const title = compositeTitle || baseValue || source.columnist_name || '';
    const searchValue = program || source.columnist_name || contentName || baseValue || title;
    const key = (item && item._id) || `columnista-${fallbackIndex}`;
    return {
      source,
      title,
      description,
      searchValue,
      key
    };
  }

  handleColumnistSuggestionSelect = (item, metaFromCaller) => {
    const meta = metaFromCaller || this.extractColumnistSuggestionMeta(item);
    const nextValue = meta.searchValue || meta.title || '';
    if (this.dataSearchRef && this.dataSearchRef.current && typeof this.dataSearchRef.current.setValue === 'function') {
      this.dataSearchRef.current.setValue(nextValue, true);
    }
    this.setState({
      searchValue: nextValue
    }, this.ensureDefaultSectionSelected);
  }

  isColumnistSuggestion = (item) => {
    console.log("isColumnistSuggestion",);
    if (!item) {
      return false;
    }

    const secName = item.source.sec_name || '';

    console.log("secName", secName);
    if (!secName) {
      return false;
    }
    return secName.includes('COLUMNAS');
  }

  clearColumnistSuggestions = () => {
    this.columnistSuggestionsBuffer = [];
  }


  handleLoadSyntheis = (menu) => {
    this.setState({
      idMenuSelected: menu.menu_id,
      isLoading: true
    }, () => {
      window.location.href = `/app`;
      ls.set('menuSelected', this.state.idMenuSelected);
    })
  }

  //Open - Close drawer
  handleOnClose = (open) => {
    this.setState({ isOpen: open });
  }

  renderCard = (item) => {
    if (item.length > 0) {
      let type = [];
      let editorialCard = [];
      item.map(
        i => {
          if (i.menu_id === this.state.idMenuSelected && (!noRender.includes(item.sec_tipo))) {
            if (!type.filter(x => x.sec_tipo === i.sec_tipo && x.sec_name === i.sec_name)[0]) {
              let newData = [];
              let aux = item.filter(x => x.sec_tipo === i.sec_tipo && x.sec_name === i.sec_name && x.menu_id === this.state.idMenuSelected);
              aux.map(
                (item) => {
                  if (item.publish_date && !Number.isInteger(item.publish_date) && `${item.publish_date}`.indexOf('-') === -1) {
                    // let f = parseFloat(item.publish_date);
                    // let date = new Date(f);
                    item.publish_date = _getDateShort(parseFloat(item.publish_date))//date.toISOString().split('T')[0]
                  } else {
                    // let date = new Date(item.publish_date);
                    item.publish_date = _getDateShort(item.publish_date) //date.toISOString().split('T')[0]
                  }
                  item.cont_imagePath = item.cont_imagePath ? item.cont_imagePath : (item.cont_imagepath ? item.cont_imagepath : "")
                  if (item.publish_date)
                    newData.push(item);
                }
              );
              if (i.sec_tipo === "NotasEditoriales" || i.sec_tipo === "Card") {
                editorialCard = [...editorialCard, ...newData];
              }
              type.push(
                {
                  sec_tipo: i.sec_tipo,
                  sec_color: i.sec_color,
                  sec_name: i.sec_name,
                  sec_icono: i.sec_icono,
                  content: newData
                }
              );
            }
          }
        }
      );
      if (editorialCard.length > 0) {
        type.push(
          {
            sec_tipo: "EditorialCard",
            content: editorialCard
          }
        );
      }
      return type.map(
        (i, k) => {
          if (i.content.length > 0) {
            switch (i.sec_tipo) {
              case "Relevante": return <SliderTap isSearching section={i} idMenuSelected={this.state.idMenuSelected} key={k} />
              case "Portada": return (
                <div id={i.sec_name ? i.sec_name.toString().trim() : ""} key={i}>
                  <div style={{ backgroundColor: i.sec_color, paddingTop: 25 }}>
                    <PapperBlock secName={i.sec_name.toString().trim()} img={i.sec_icono} isVisible={true} title={i.sec_name} isSearching colorTitle={i.sec_color}>
                      <CardButton isSearching type="Portada" section={i} idMenuSelected={this.state.idMenuSelected} key={k} />
                    </PapperBlock>
                  </div>
                </div>
              )
              case "Notas": return (
                <div style={{ backgroundColor: i.sec_color }} key={k}>
                  <PapperBlock secName={i.sec_name.toString().trim()} img={i.sec_icono} title={i.sec_name} isSearching desc="" colorTitle={i.sec_color}>
                    <GridCard isSearching section={i} idMenuSelected={this.state.idMenuSelected} isWhiteBackground />
                  </PapperBlock>
                </div>)
              case "NotasColumnas": return (
                <div style={{ backgroundColor: i.sec_color }} key={k}>
                  <PapperBlock secName={i.sec_name.toString().trim()} img={i.sec_icono} title={i.sec_name} isSearching desc="" colorTitle={i.sec_color}>
                    <SliderEditoriales isSearching section={i} viewGrid idMenuSelected={this.state.idMenuSelected} autor />
                  </PapperBlock>
                </div>)
              case "EditorialCard":
                return (
                  <div id={i.sec_name ? i.sec_name.toString().trim() : ""} key={k}>
                    <div style={{ backgroundColor: i.sec_color, paddingTop: 25 }}>
                        <CardButton isSearching type={i.sec_tipo} section={i} idMenuSelected={this.state.idMenuSelected} key={k} />
                    </div>
                  </div>
                )
              case "Radio": return (
                <div style={{ backgroundColor: i.sec_color }} key={k}>
                  <PapperBlock secName={i.sec_name.toString().trim()} img={i.sec_icono} title={i.sec_name} isSearching desc="">
                    <SliderRadio isSearching section={i} idMenuSelected={this.state.idMenuSelected} />
                  </PapperBlock>
                </div>)
              case "Evento": return (
                <div style={{ backgroundColor: i.sec_color }} key={k}>
                  <PapperBlock secName={i.sec_name.toString().trim()} img={i.sec_icono} title={i.sec_name} isSearching desc="">
                    {/* <SliderEvent isSearching section={i} idMenuSelected={this.state.idMenuSelected} /> */}
                    <Event isSearching section={i} idMenuSelected={this.state.idMenuSelected} />
                  </PapperBlock>
                </div>)
              case "Portada":
                return <Portadas isSearching section={i} idMenuSelected={this.state.idMenuSelected} key={k} colorMode />
              default:
            }
          }
        }
      )
    } else {
      return null;
    }
  }

  handleCloseNotification = () => {
    this.setState(
      {
        openNotification: false
      }
    )
  }

  query = (value, props) => {
    if (value) {
      let start = new Date(value.start)
      let end = new Date(value.end)
      if (end < start) {
        this.setState(
          {
            openNotification: true,
            messageNotification: `Selección de fechas incorrecto`,
            typeNotification: "warning",
          }
        );
      }
      start.setHours(24);
      end.setHours(24)
      end.setHours(end.getHours() + 23, 59)
      return {
        query: {
          range: { "publish_date": { "gte": start.getTime(), "lte": end.getTime() } }
        }
      }
    }
  }

  queryDataSearch = (value, props) => {
    if (value) {
      let start = new Date(value.start)
      let end = new Date(value.end)
      start.setHours(24);
      end.setHours(24)
      end.setHours(end.getHours() + 23, 59)
      return {
        "query": { "bool": { "must": [{ "bool": { "must": [{ "bool": { "should": [{ "multi_match": { "query": "Suspensión de Clases", "fields": ["menu_name", "sec_name", "cont_name", "cont_description", "cont_program"], "type": "cross_fields", "operator": "and" } }, { "multi_match": { "query": "Suspensión de Clases", "fields": ["menu_name", "sec_name", "cont_name", "cont_description", "cont_program"], "type": "phrase", "operator": "and" } }], "minimum_should_match": "1" } }, { "match": { "menu_name": "Negocios" } }] } }] } }, "size": 100, "_source": { "includes": ["*"], "excludes": [] }, "from": 0, "sort": [{ "sec_order": { "order": "asc" } }]
      }
    }
  }

  render() {
    const title = brand.name;
    const description = brand.desc;
    const { classes } = this.props;
    if (this.state.kicker.length > 0 && this.state.availableSection.length > 0) {

      return (
        <div className={classes.WrapperSearch}>
          <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
          </Helmet>
          <div className={classes.containerBack}>
            <Link to="/app">
              <Button className={classes.button}>
                <ArrowBack className={classes.leftIcon} />
                Regresar
              </Button>
            </Link>
            {false && <SintesisMenu loadSynthesis={(item) => { this.handleLoadSyntheis(item) }} synthesis={this.state.synthesisAvailable} selected={this.state.idMenuSelected} isSearching />}
          </div>
          <ReactiveBaseStyle
            url={process.env.REACT_APP_ELASTICBEHAVIOR}
            app={process.env.REACT_APP_ELASTICINDEX}
          >
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <div className={classes.wrapperForm}>
                  <AppBar
                    className={classNames(
                      classes.contentWidth,
                      classes.appSearch,
                      { [classes.contentWidthShift]: this.state.isOpen }
                    )}
                    position="static"
                    color="inherit"
                    elevation={0}>
                    <Toolbar className={classes.inputSearch}>
                      {/* <div className={classes.flex}>
                        <div className={classes.wrapper}> */}
                      <div className={classes.search}>
                        <SearchIcon />
                      </div>
                      <DataSearch
                        ref={this.dataSearchRef}
                        showIcon={false}
                        filterLabel="Buscar"
                        className={classes.input}
                        minChars={2}
                        dataField={["menu_name", "sec_name", "cont_name", "cont_description", "cont_program"]}
                        componentId="SearchSensor"
                        innerClass={{
                          input: 'search-input'
                        }}
                        placeholder="Buscar"
                        queryFormat="and"
                        react={{
                          and: ['SectionSensor', 'DateSensor', 'KickerSensor', 'ColumnistSensor', 'SynthesisSensor']
                        }}
                        onValueSelected={(value, cause, source) => {
                          this.clearColumnistSuggestions();
                          const nextValue = typeof value === 'string' ? value : (value || '');
                          this.setState({
                            searchValue: nextValue
                          }, this.ensureDefaultSectionSelected);
                        }}
                        onValueChange={value => {
                          const nextValue = value || '';
                          if (!nextValue) {
                            this.clearColumnistSuggestions();
                          }
                          this.setState({
                            searchValue: nextValue
                          }, () => {
                            if (nextValue) {
                              this.ensureDefaultSectionSelected();
                            }
                          });
                          return null;
                        }}
                        render={({ data, value, downshiftProps }) => {
                          const menuHelpers = downshiftProps || {};
                          const { isOpen, getMenuProps, highlightedIndex } = menuHelpers;

                          // don't render suggestions if downshift not open or value is empty or less than 2 chars
                          if (!(isOpen && value) || (value && value.length < 2)) {
                            return null;
                          }

                          const suggestions = Array.isArray(data) ? data : [];

                          console.log("suggestions real", suggestions);

                          const columnists = suggestions.filter(item => this.isColumnistSuggestion(item));
                          console.log("columnists", columnists);
                          const others = suggestions.filter(item => !this.isColumnistSuggestion(item));
                          console.log("others", others);

                          this.columnistSuggestionsBuffer = columnists;

                          if (!columnists.length && !others.length) {
                            return null;
                          }

                          const menuProps = getMenuProps
                            ? getMenuProps({ className: classes.suggestionWrapper }, { suppressRefError: true })
                            : { className: classes.suggestionWrapper };
                          return (
                            <div {...menuProps}>
                              {columnists.length > 0 && (
                                <React.Fragment>
                                  <div className={classes.suggestionGroupLabel}>Columnistas</div>
                                  {columnists.map((item, index) => {
                                    console.log("item del col", item);
                                    const meta = this.extractColumnistSuggestionMeta(item, index);
                                    console.log("meta", meta);
                                    const displayTitle = meta.title || 'Sin título';
                                    const displayDescription = meta.description || 'Sin descripción';
                                    const titleNode = this.renderHighlightedText(displayTitle, value);
                                    const descriptionNode = displayDescription ? this.renderHighlightedText(displayDescription, value) : null;

                                    return (
                                      <div
                                        key={meta.key}
                                        onClick={() => {
                                          const searchValue = String(meta.searchValue || displayTitle || '');
                                          if (this.dataSearchRef && this.dataSearchRef.current && typeof this.dataSearchRef.current.setValue === 'function') {
                                            this.dataSearchRef.current.setValue(searchValue, true);
                                          }
                                          this.setState({
                                            searchValue: meta.source.cont_program || searchValue
                                          }, this.ensureDefaultSectionSelected);
                                        }}
                                        className={classNames(
                                          classes.suggestionItem,
                                          {
                                            [classes.suggestionItemActive]: highlightedIndex === index
                                          }
                                        )}
                                      >
                                        <div className={classes.suggestionTitle}>
                                          {titleNode}
                                        </div>

                                      </div>
                                    );
                                  })}
                                </React.Fragment>
                              )}
                              <Divider />
                              {others.length > 0 && (
                                <React.Fragment>
                                  {others.map((item, idx) => {
                                    const index = columnists.length + idx;
                                    const itemValue = this.stripHtml(item.value);
                                    const source = item._source || {};
                                    const key = item._id || `${itemValue}-${index}`;
                                    const displayTitle = source.cont_name || itemValue || '';
                                    const displaySubtitle = source.sec_name || '';
                                    const titleNode = this.renderHighlightedText(displayTitle, value);
                                    const subtitleNode = displaySubtitle ? this.renderHighlightedText(displaySubtitle, value) : null;
                                    return (
                                      <div
                                        key={key}
                                        onClick={() => {
                                          const searchValue = String(itemValue || displayTitle || '');
                                          if (this.dataSearchRef && this.dataSearchRef.current && typeof this.dataSearchRef.current.setValue === 'function') {
                                            this.dataSearchRef.current.setValue(searchValue, true);
                                          }
                                          this.setState({
                                            searchValue: searchValue
                                          }, this.ensureDefaultSectionSelected);
                                        }}
                                        className={classNames(
                                          classes.suggestionItem,
                                          {
                                            [classes.suggestionItemActive]: highlightedIndex === index
                                          }
                                        )}
                                      >
                                        <div className={classes.suggestionTitle}>
                                          {titleNode}
                                        </div>
                                        {displaySubtitle && (
                                          <div className={classes.suggestionSubtitle}>{subtitleNode}</div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </React.Fragment>
                              )}
                            </div>
                          );
                        }}
                      />
                    </Toolbar>
                  </AppBar>


                  <div className={classes.contentFilters}>
                    <Hidden xsDown>
                      <Button
                        onClick={() => this.handleOnClose(true)}
                        className={classes.filtroBtn}>
                        <FilterList /> Filtros
                      </Button>
                    </Hidden>
                    <Hidden smUp>
                      <IconButton
                        onClick={() => this.handleOnClose(true)}
                        className={classes.filtroIconBtn}
                        aria-label="Filtros"
                      >
                        <FilterList />
                      </IconButton>
                    </Hidden>
                    <Hidden xsDown>
                      <div className={classes.contentRange}>
                        <div className={classes.search}>
                          <Today />
                        </div>
                        <DateRange
                          componentId="DateSensor"
                          dataField="publish_date"
                          initialMonth={new Date()}
                          className={classes.inputDate}
                          innerClass={{
                            overlayWrapper: 'theme',
                          }}
                          filterLabel="Fecha"
                          react={{
                            and: ['SearchSensor', 'SectionSensor', 'KickerSensor', 'ColumnistSensor', 'SynthesisSensor']
                          }}
                          // defaultValue={this.state.date}
                          showClear={false}
                          inputProps={{
                            readOnly: true
                          }}
                          dayPickerInputProps={{
                            dayPickerProps: {
                              locale: 'es',
                              localeUtils: MomentLocaleUtils,
                            }
                          }}
                          placeholder={{
                            start: 'Desde',
                            end: 'Hasta'
                          }}
                          customQuery={
                            this.query
                          }
                          onValueChange={value => this.setState({ dateValue: value })}
                        />
                      </div>
                    </Hidden>
                  </div>
                </div>


                <Drawer anchor="right" variant="persistent" open={this.state.isOpen} onClose={() => this.handleOnClose(false)} className={classes.drawer}>
                  <div className={classes.drawerHeader}>
                    <Typography variant="title" component="h5" className={classes.titleFil}>
                      Filtros
                    </Typography>
                    <IconButton onClick={() => this.handleOnClose(false)}>
                      {<KeyboardTab />}
                    </IconButton>
                  </div>
                  <Divider />
                  <div className={classes.filterContainer}>
                    <div className={classes.filterForm}>
                      <Hidden smUp>
                        <div className={classes.contentRange} style={{ marginBottom: 20 }}>
                          <div className={classes.search}>
                            <Today />
                          </div>
                          <DateRange
                            componentId="DateSensor"
                            dataField="publish_date"
                            initialMonth={new Date()}
                            className={classNames(classes.inputDate, classes.inputDateMobile)}
                            innerClass={{
                              overlayWrapper: 'theme',
                            }}
                            filterLabel="Fecha"
                            react={{
                              and: ['SearchSensor', 'SectionSensor', 'KickerSensor', 'ColumnistSensor', 'SynthesisSensor']
                            }}
                            // defaultValue={this.state.date}
                            showClear={false}
                            inputProps={{
                              readOnly: true
                            }}
                            dayPickerInputProps={{
                              dayPickerProps: {
                                locale: 'es',
                                localeUtils: MomentLocaleUtils,
                              }
                            }}
                            placeholder={{
                              start: 'Desde',
                              end: 'Hasta'
                            }}
                            customQuery={
                              this.query
                            }
                            onValueChange={value => this.setState({ dateValue: value })}
                          />
                        </div>
                      </Hidden>
                      <MultiDataList
                        componentId="ColumnistSensor"
                        dataField="cont_program.keyword"
                        data={this.state.columnists}
                        title="Columnistas"
                        showCheckbox={true}
                        showSearch={false}
                        filterLabel="Columnista"
                        showFilter={true}
                        innerClass={{
                          list: classes.wraper,
                          count: classes.count,
                          checkbox: classes.checkFilterInput,
                          label: classes.checkFilterLabel
                        }}
                        react={{
                          and: ['SearchSensor', 'SectionSensor', 'KickerSensor', 'DateSensor', 'SynthesisSensor']
                        }}
                        loader="Cargando..."
                        onValueChange={value => this.setState({ columnistValue: value })}
                      />

                      <MultiDataList
                        componentId="SynthesisSensor"
                        dataField="menu_name.keyword"
                        data={this.state.allSynthesis}
                        title="Síntesis"
                        showCheckbox={true}
                        showSearch={false}
                        filterLabel="Síntesis"
                        showFilter={true}
                        innerClass={{
                          list: classes.wraper,
                          count: classes.count,
                          checkbox: classes.checkFilterInput,
                          label: classes.checkFilterLabel
                        }}
                        react={{
                          and: ['SearchSensor', 'SectionSensor', 'KickerSensor', 'DateSensor', 'ColumnistSensor']
                        }}
                        loader="Cargando..."
                        onValueChange={value => this.setState({ synthesisValue: value })}
                      />

                      <MultiDataList
                        componentId="SectionSensor"
                        dataField="sec_name.keyword"
                        data={this.state.availableSection}
                        title="Secciones disponibles"
                        // selectAllLabel="Seleccionar Todo"
                        showCheckbox={true}
                        showSearch={false}
                        filterLabel="Sección"
                        placeholder="Buscar Sección"
                        showFilter={true}
                        // value={this.state.sectionValue}
                        innerClass={{
                          list: classes.wraper,
                          count: classes.count,
                          checkbox: classes.checkFilterInput,
                          label: classes.checkFilterLabel
                        }}
                        react={{
                          and: ['SearchSensor', 'DateSensor', 'KickerSensor', 'ColumnistSensor', 'SynthesisSensor']
                        }}
                        loader="Cargando..."
                        onValueChange={value => this.setState({ sectionValue: value })}
                      />
                      <MultiDataList
                        componentId="KickerSensor"
                        dataField="cont_program.keyword"
                        data={this.state.kicker}
                        title="Kicker"
                        selectAllLabe={false}
                        showCheckbox={true}
                        showSearch={false}
                        filterLabel="Kicker"
                        showFilter={true}
                        innerClass={{
                          list: classes.wraper,
                          count: classes.count,
                          checkbox: classes.checkFilterInput,
                          label: classes.checkFilterLabel
                        }}
                        react={{
                          and: ['SearchSensor', 'SectionSensor', 'DateSensor', 'ColumnistSensor', 'SynthesisSensor']
                        }}
                        loader="Cargando..."
                        onValueChange={value => this.setState({ kickerValue: value })}
                      />


                    </div>
                  </div>
                </Drawer>
              </Grid>


              <Grid item xs={12}>
                <SelectedFilters clearAllLabel="Limpiar filtros" showClearAll={false} />
              </Grid>
              {/* RESULTS */}
              <Grid item xs={12} style={{paddingBottom: 80}}>
                {(this.state.searchValue == "" &&
                  this.state.sectionValue.length == 0 &&
                  this.state.kickerValue.length == 0 &&
                  this.state.columnistValue.length == 0 &&
                  this.state.synthesisValue.length == 0 &&
                  this.state.dateValue == null) ?
                  <div className={classes.contentNull}><label style={{ color: '#A9A9A9', fontSize: 14 }}>Buscar secciones y notas</label></div> :
                  <ReactiveList
                    className={classNames("right-col", classes.contentWidth, { [classes.contentWidthShift]: this.state.isOpen })}
                    componentId="SearchResult"
                    //dataField={["menu_name","sec_name","sec_tipo", "cont_name","cont_description"]}
                    dataField={"cont_name"}
                    size={100}
                    pagination={true}
                    renderPagination={({ pages, totalPages, currentPage, setPage }) => {
                                            const allPages = Array.isArray(pages) ? pages : Array.from({ length: totalPages }, (_, i) => i);
                                            
                                            const getVisiblePages = () => {
                                                const maxVisible = 5;
                                                const half = Math.floor(maxVisible / 2);
                                                
                                                let start = Math.max(0, currentPage - half);
                                                let end = Math.min(totalPages - 1, start + maxVisible - 1);
                                                
                                                if (end - start + 1 < maxVisible) {
                                                    start = Math.max(0, end - maxVisible + 1);
                                                }
                                                
                                                return allPages.slice(start, end + 1);
                                            };
                                            
                                            const visiblePages = getVisiblePages();
                                            const showPagination = allPages.length > 0;
                                            
                                            return (
                                                <div className={showPagination ? classes.pagination : classes.paginationHidden}>
                                                    <Button
                                                        size="sm"
                                                        variant="outline"
                                                        onClick={() => setPage(currentPage - 1)}
                                                        disabled={currentPage === 0}
                                                    >
                                                        Anterior
                                                    </Button>
                                                
                                                    {visiblePages.map((page) => (
                                                        <Button
                                                            size="sm"
                                                            variant={currentPage === page ? "contained" : "ghost"}
                                                            color={currentPage === page ? "primary" : ""}
                                                            key={page}
                                                            onClick={() => setPage(page)}
                                                            className={classes.numbersBtns}
                                                        >
                                                        {page + 1}
                                                        </Button>
                                                    ))}
                                                
                                                    <Button
                                                        size="sm"
                                                        variant="outline"
                                                        onClick={() => setPage(currentPage + 1)}
                                                        disabled={currentPage === totalPages - 1}
                                                    >
                                                        Siguiente
                                                    </Button>
                                                </div>
                                            )
                                        }}
                    loader="Cargando resultados..."
                    renderResultStats={
                      function (stats) {
                        return (
                          ``/*`${stats.numberOfResults} resultados encontrados en ${stats.time} ms`*/
                        )
                      }
                    }
                    defaultQuery={() => {
                      return {
                        query: {
                          match: {
                            menu_name: this.state.currentMenu
                          },
                        },
                        "sort": [
                          {
                            // "sec_order": {
                            //   "order": "asc"
                            // },
                            publish_id: {
                              order: "desc"
                            }
                          }
                        ]
                      }
                    }
                    }
                    renderNoResults={() => { return (<div className={classes.contentNull}><label style={{ color: '#A9A9A9', fontSize: 14 }}>No se encontraron coincidencias.</label></div>) }}
                    paginationAt="bottom"
                    prevLabel="Anterior"
                    nextLabel="Siguiente"
                    innerClass={{
                      pagination: 'page',
                      active: 'activeBtn'
                    }}
                    react={{
                      and: ['SectionSensor', 'DateSensor', 'KickerSensor', 'ColumnistSensor', 'SynthesisSensor'],
                      or: ['SearchSensor']
                    }}
                    render={
                      ({ loading,
                        error,
                        data,
                        streamData,
                        promotedData,
                        rawData,
                        resultStats,
                        handleLoadMore,
                        triggerAnalytics }) => {

                        return this.renderCard(data);
                      }
                    }
                  />}
              </Grid>
            </Grid>
          </ReactiveBaseStyle>
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={this.state.openNotification}
            autoHideDuration={6000}
            onClose={this.handleCloseNotification}>
            <CustomNotification
              onClose={this.handleCloseNotification}
              variant={this.state.typeNotification}
              message={this.state.messageNotification} />
          </Snackbar>
          <Footer loadSynthesis={(item) => { this.handleLoadSyntheis(item) }} menu={this.state.synthesisAvailable} section={this.state.synthesisSections} />
        </div>
      );
    } else {
      return <LoaderFull />
    }
  }
}

Search.propTypes = {
  classes: PropTypes.object.isRequired,
};

Search.contextType = ThemeContext;

export default withStyles(styles)(Search);
